import { Component, OnInit, Input, EventEmitter } from '@angular/core'
import { ActionComponent, Module, Payload } from '@bp/core'
import { NzMessageService } from 'ng-zorro-antd'
import { SharedHttpService } from '~/shared/http/shared-http.service'
import { FormBuilder, Validators } from '@angular/forms'

@Component({
  selector: 'app-template-enabled-switcher',
  templateUrl: './template-enabled-switcher.component.html',
  styleUrls: ['./template-enabled-switcher.component.styl'],
})
export class TemplateEnabledSwitcherComponent extends ActionComponent implements OnInit {
  static meta = {
    type: 'custom_action',
    name: 'template-enabled-switcher',
  }

  dispatch = new EventEmitter<Payload>()

  @Input() entity: any
  @Input() module: Module

  constructor(
    private _sharedHttp: SharedHttpService,
    private _msgService: NzMessageService,
    private _fb: FormBuilder,
  ) {
    super()
  }

  ngOnInit() {}

  handleEnabled(enabled) {
    this._sharedHttp.templateBatch(
      this.entity.id,
      'refresh',
      { enabled }
    ).subscribe(res => {
      this._msgService.success('操作成功')
      this.dispatch.emit({ type: 'refresh' })
    })
  }
}
